export const YOUTUBE_URL_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/
export const VIMEO_URL_REGEX = /^https?:\/\/vimeo\.com\/(?:video\/)?(\d+)/
export const JW_PLAYER_URL_REGEX = /^https?:\/\/cdn\.jwplayer\.com\/manifests\/([a-zA-Z0-9]+)/
